// ev_station
export const mdEvStation = [
  '24, 24',
  '<path d="m8.5 19 2.5-4H9.5v-3L7 16h1.5ZM6 10h6V5H6Zm0 9h6v-7H6Zm-2 2V5q0-.825.588-1.413Q5.175 3 6 3h6q.825 0 1.413.587Q14 4.175 14 5v7h1.25q.725 0 1.238.512.512.513.512 1.238v4.625q0 .425.35.775.35.35.775.35.45 0 .788-.35.337-.35.337-.775V9H19q-.425 0-.712-.288Q18 8.425 18 8V6h.5V4.5h1V6h1V4.5h1V6h.5v2q0 .425-.288.712Q21.425 9 21 9h-.25v9.375q0 1.05-.762 1.837-.763.788-1.863.788-1.075 0-1.85-.788-.775-.787-.775-1.837V13.75q0-.125-.062-.188-.063-.062-.188-.062H14V21Zm8-2H6h6Z"/>'
]
